import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

export const PasswordInput = ({ id, value, onChange, testId, placeholder = "••••••••", required = true }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        type={show ? "text" : "password"}
        required={required}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={testId}
        className="rounded-sm border-stone-300 bg-white pr-10"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}
        tabIndex={-1}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 transition-colors duration-150 hover:text-stone-700"
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};
